// extracted by mini-css-extract-plugin
module.exports = {"root":"m-complex_item__3jFUZlcv"};